<script lang="ts">

	import type { LayerName } from '$lib/components/map/map-styles';
	import type { ClassValue } from 'svelte/elements';
	import MapLayerHistoriqueImg from '$assets/map/MapLayerHistorique.webp';
	import MapLayerHybrideImg from '$assets/map/MapLayerHybride.webp';
	import MapLayerMichelinImg from '$assets/map/MapLayerMichelin.webp';
	import MapLayerScenicImg from '$assets/map/MapLayerScenic.webp';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		layer: LayerName;
		selected?: boolean;
		class?: ClassValue;
		onclick?: () => void;
	}

	const {
		layer,
		selected = false,
		class: classes,
		onclick,
	}: Props = $props();

	const images: Record<LayerName, string> = {
		michelin: MapLayerMichelinImg,
		historic: MapLayerHistoriqueImg,
		hybrid: MapLayerHybrideImg,
		scenic: MapLayerScenicImg,
	};

	const layerLabels: Record<LayerName, string> = {
		scenic: m.layers__scenic__label(),
		michelin: m.layers__michelin__label(),
		historic: m.layers__historic__label(),
		hybrid: m.layers__hybrid__label(),
	};

	const layerAlt: Record<LayerName, string> = {
		scenic: m.layers__scenic__imagex_alt(),
		michelin: m.layers__michelin__imagex_alt(),
		historic: m.layers__historic__image_alt(),
		hybrid: m.layers__hybrid__image_alt(),
	};
</script>

<button
	aria-label={layerAlt[layer]}
	aria-pressed={selected}
	class={['option flex-grow relative h-32 b-0 p-0 rd-1 overflow-hidden cursor-pointer', classes]}
	{onclick}
>
	<span class="overlay absolute w-full h-full rd-1"></span>
	<span class="absolute top-1 left-1">
		<Badge text={layerLabels[layer]} color={selected ? 'primary' : 'inverted'} />
	</span>
	<Image class="object-cover h-full w-full" src={images[layer]} alt={layerAlt[layer]} />
</button>

<style>
	.option:hover .overlay {
		box-shadow: 0px 0px 20px 0px rgba(29, 49, 64, 0.5) inset;
	}
</style>
